{
    "especial": {
        "titulo": "Suggestion / Consultation",
        "conf_consulta": "Bonjour ! Merci beaucoup pour votre suggestion/question. Le Comité d'éthique sera en charge d'étudier votre proposition. Nous vous tiendrons informé de l'évolution du dossier, ainsi que de la décision finale !"
    },
    "actions": {
        "close": "Fermer",
        "send": "Envoyer",
        "toattach": "Documentation / Preuve",
        "save": "Enregistrer",
        "clean": "Nettoyer",
        "singin": "Se connecter",
        "restore": "Récupérer",
        "return": "Retour",
        "confirm": "Accepter",
        "cancel": "Annuler",
        "access": "Accéder",
        "create": "Créer",
        "cerrarFase": "Fermer la phase",
        "listen": "Écouter"
    },
    "forms": {
        "title": "Que devez-vous faire?",
        "fraseinicial": "TRÈS IMPORTANT: Si la plainte peut affecter l'administrateur de la société ou l'un des membres du Comité d'éthique, veuillez toujours utiliser le formulaire de plainte ANONYME. De plus, vous pouvez nous contacter pour en savoir plus sur notre Comité d'éthique et le reste de notre système de conformité, via les canaux de contact habituels avec notre organisation.",
        "subtitle": "Ici, vous pouvez nous signaler des incidents ou nous poser des questions sur les violations légales, les violations de nos directives et procédures ou les violations de tout autre type",
        "subtitle2": "Ce n'est pas un service d'urgence. Face à tout danger imminent, adressez-vous aux autorités compétentes",
        "complaintsChannel": "Canal des plaintes",
        "consult": "Consulter",
        "anonymous": "Anonyme",
        "nominal": "Nominal",
        "voice": "Voix",
        "voice_record": "Démarrer l'enregistrement",
        "voice_stop": "Arrêter l'enregistrement",
        "voice_recording ": "Enregistrement...",
        "voice_recorded ": "Enregistrement terminé",
        "voice_instructions": "<strong>Avis :</strong> La voix ne sera pas distordue.",
        "voice_error": "Erreur lors de l'accès au microphone. Veuillez vous assurer que vous avez accordé les autorisations nécessaires et que votre appareil dispose d'un microphone fonctionnel.",
        "complaint": "Plainte",
        "finalMesssage": "Vous pouvez consulter son statut via l'url: ",
        "finalMesssage2": "En entrant le code suivant: ",
        "finalMessage3": "Vous pouvez imprimer une copie ou enregistrer en PDF en faisant ",
        "finalDenuncia": "Si vous souhaitez suivre l'évolution de la plainte, conservez le lien et le code qui apparaissent à l'écran.",
        "finalDenuncia2": "Nous vous recommandons d'accéder fréquemment à votre plainte pour vérifier si nous avons pris contact avec vous.",
        "typeChannel": "Que voulez-vous faire?",
        "typeComplaint": "Type de délit",
        "answer": "Réponse",
        "email": "Email",
        "name": "Nom",
        "user": "Utilisateur",
        "password": "Mot de passe",
        "privacity": "J'ai lu et j'accepte la ",
        "privacity2": "J'ai lu la ",
        "capa1_GEN": "Responsable du traitement: ",
        "capa2_GEN": ". Finalité : Suivi, gestion et résolution de la demande reçue par le canal éthique. Exercice des droits et plus d’informations sur le traitement des données :",
        "capa1_1": "Conformément aux réglementations sur la protection des données, nous vous fournissons les informations suivantes sur le traitement:",
        "capa1_2": "Responsable: HEALTH TIME, S.L. (CI-APRÈS HT MEDICA).",
        "capa1_3": "Objectifs du traitement: gérer correctement notre canal éthique, traiter les irrégularités correspondantes signalées à travers celui-ci",
        "capa1_4": "Droits qui vous sont accordés: accès, rectification, portabilité, suppression, limitation et opposition",
        "capa1_5": "Plus d'informations sur le traitement dans notre politique de confidentialité",
        "capa1_6": "Votre consentement est nécessaire pour le traitement ultérieur de ces données dans la procédure et sans lesquelles il ne serait pas possible de traiter votre demande.",
        "anonimato": "Pour maintenir l'anonymat, il est recommandé de ne télécharger que des fichiers au format PDF ",
        "policy": "Politique de Confidentialité",
        "consultation": {
            "name": "Nom",
            "surname": "Prénom",
            "phone": "Téléphone",
            "email": "Email",
            "ordinario": "Courrier ordinaire",
            "otromedia": "Autre moyen de communication?",
            "anompo": "Anonymisé par ",
            "mediocom": "Moyen de communication",
            "otros": "Autres",
            "organization": "Organisation à laquelle vous appartenez",
            "relationship": "Quelle relation avez-vous?",
            "message": "Quelle est votre question / plainte?",
            "nature": "Nature de la question / plainte",
            "notificacionMensaje": "Recevoir des notifications par ",
            "bloquear": "Le responsable du canal (Compliance Officer) ou l'organe de gouvernement est-il impliqué dans les faits dénoncés? ",
            "bloqueoOrgano": "Oui, l'Organe de Gouvernement (ne recevra pas de notification de la plainte)",
            "bloqueoOffice": "Oui, le Compliance Officer (ne recevra pas de notification de la plainte)",
            "bloquearEsp": "Le responsable du canal  ou l'organe de gouvernement est-il impliqué dans les faits dénoncés? ",
            "bloqueoOrganoEsp": "Oui, l'Organe de Gouvernement (ne recevra pas de notification de la plainte)",
            "bloqueoOfficeEsp": "Oui, le responsable du canal (ne recevra pas de notification de la plainte)",
            "defajenos": "Votre plainte va être anonymisée car elle comprend des données personnelles qui ne sont pas liées aux faits dénoncés. Veuillez renvoyer la plainte sans inclure ces données.",
            "defsensibles": "Votre plainte va être anonymisée car elle comprend des données personnelles appartenant aux catégories spéciales de données. Veuillez renvoyer la plainte sans inclure ces données."
        },
        "comp": {
            "whatComp": "Quelle est votre plainte?",
            "involved": "Personne/s impliquée/s",
            "involved2": "Si vous ne connaissez pas l'identité de la/les personne/s impliquée/s, écrivez `Je ne sais pas`",
            "department": "Département affecté",
            "headquarters": "Siège affecté",
            "otherComplaints": "Description de la plainte",
            "other": "Détaillez d'autres délits",
            "nature": "Nature de la plainte",
            "when": "Quand l'incident s'est-il produit?",
            "reiterativo": "L'incident est-il récurrent?",
            "yes": "Oui",
            "no": "Non",
            "bloqmiembro": "Bloquer le membre"
        },
        "principalBreadCrumb": "Question ou Plainte",
        "profile": "Voir profil",
        "settings": "Paramètres",
        "contact": "Contact",
        "signout": "Se déconnecter",
        "imgText": "Glissez et déposez les documents ou cliquez ici"
    },
    "login": {
        "user": "Nom d'utilisateur",
        "password": "Mot de passe",
        "forgot": "Vous avez oublié votre mot de passe?",
        "title": "Identification du super utilisateur",
        "titleEmp": "Identification de l'entreprise",
        "titleUser": "Identification de l'utilisateur",
        "restore": "Récupérer",
        "titleRestore": "Récupérer mot de passe",
        "finalMesssage": "Votre mot de passe a été récupéré.",
        "restoreFail": "Une erreur s'est produite, veuillez réessayer.",
        "email": "Email",
        "errorUsu": "Nom d'utilisateur ou mot de passe incorrect",
        "errorBlock": "L'utilisateur est bloqué, veuillez contacter un administrateur pour le débloquer",
        "restoreFailEmail": "Le format de l'email n'est pas valide"
    },
    "error": {
        "name": "Le nom est un champ obligatoire",
        "user": "L'utilisateur est un champ obligatoire"
    },
    "menu": {
        "complaintsChannel": "Canal de Plaintes",
        "mcompany": "CRÉER UNE ENTREPRISE",
        "msuperuser": "CRÉER UN SUPERUTILISATEUR",
        "roleMain": "MAINTENANCE des rôles",
        "countryMain": "MAINTENANCE DES PAYS",
        "offenseMain": "MAINTENANCE DES INFRACTIONS",
        "mainLanguages": "MAINTENANCE DES LANGUES",
        "fontMain": "MAINTENANCE DES POLICES",
        "relation": "MAINTENANCE DES RELATIONS",
        "nature": "MAINTENANCE DES NATURES",
        "headquarters": "MAINTENANCE DES SIÈGES",
        "departments": "MAINTENANCE DES DÉPARTEMENTS",
        "users": "MAINTENANCE DES UTILISATEURS",
        "mydata": "MES DONNÉES",
        "statistics": "STATISTIQUES",
        "whistleblower": "DÉNONCIATEUR",
        "history": "HISTORIQUE DES CAS",
        "ocases": "CAS OUVERTS",
        "title": "Bonjour",
        "mylinks": "MES LIENS",
        "notice": "MES NOTICES",
        "noticemin": "Mes avis",
        "searcher": "CHERCHEUR",
        "config": "CONFIGURATION",
        "changep": "CHANGEMENT DE MOT DE PASSE"
    },
    "maintenance": {
        "actions": {
            "add": "Ajouter",
            "cancel": "Annuler",
            "confirm": "Confirmer"
        },
        "languages": {
            "title": "Maintenance des langues",
            "name": "Nom",
            "key": "Code",
            "deleteTitle": "Suppression de la langue {name}",
            "deleteMessage": "Êtes-vous sûr de vouloir supprimer la langue?",
            "deleteConfirm": "La langue a été supprimée",
            "deleteError": "Une erreur s'est produite pendant la suppression",
            "editTitle": "Édition de la langue {name}",
            "editMessage": "La langue a été éditée",
            "addTitle": "Ajout d'une nouvelle langue"
        },
        "countries": {
            "title": "Maintenance des pays",
            "name": "Nom",
            "id": "Code",
            "deleteTitle": "Suppression du pays {name}",
            "deleteMessage": "Êtes-vous sûr de vouloir supprimer le pays?",
            "deleteConfirmTitle": "Le pays a été supprimé",
            "deleteConfirm": "Le pays a été supprimé",
            "deleteError": "Une erreur s'est produite pendant la suppression",
            "editTitle": "Édition du pays {name}",
            "editMessage": "Le pays a été édité",
            "addTitle": "Ajout d'un nouveau pays"
        },
        "natures": {
            "title": "Maintenance des natures",
            "name": "Nom",
            "deleteTitle": "Suppression de la nature {name}",
            "deleteMessage": "Êtes-vous sûr de vouloir supprimer la nature?",
            "deleteConfirmTitle": "La nature a été supprimée",
            "deleteConfirm": "La nature a été supprimée",
            "deleteError": "Une erreur s'est produite pendant la suppression",
            "editTitle": "Édition de la nature {name}",
            "editMessage": "La nature a été éditée",
            "addTitle": "Ajout d'une nouvelle nature"
        },
        "relations": {
            "title": "Maintenance des relations",
            "name": "Nom",
            "deleteTitle": "Suppression de la relation {name}",
            "deleteMessage": "Êtes-vous sûr de vouloir supprimer la relation?",
            "deleteConfirmTitle": "La relation a été supprimée",
            "deleteConfirm": "La relation a été supprimée",
            "deleteError": "Une erreur s'est produite pendant la suppression",
            "editTitle": "Édition de la relation {name}",
            "editMessage": "La relation a été éditée",
            "addTitle": "Ajout d'une nouvelle relation"
        },
        "superusers": {
            "title": "Super utilisateur",
            "name": "Nom",
            "id": "Code",
            "email": "Email",
            "password": "Mot de passe",
            "state": "État",
            "deleteTitle": "Suppression du super utilisateur {name}",
            "deleteMessage": "Êtes-vous sûr de vouloir supprimer le super utilisateur?",
            "deleteConfirmTitle": "Le super utilisateur a été supprimé",
            "deleteConfirm": "Le super utilisateur a été supprimé",
            "deleteError": "Une erreur s'est produite pendant la suppression",
            "editTitle": "Édition du super utilisateur {name}",
            "editMessage": "Le super utilisateur a été édité",
            "addTitle": "Ajout d'un nouveau super utilisateur",
            "lock": "Déverrouiller"
        },
        "companies": {
            "title": "Entreprises",
            "name": "Nom",
            "cif": "CIF",
            "email": "Email",
            "password": "Mot de passe",
            "direction": "Direction",
            "population": "Population",
            "cp": "CP",
            "user": "Utilisateur",
            "province": "Province",
            "group": "À quel groupe appartient-il?",
            "logo": "Logo",
            "designType": "Type de design",
            "companyType": "Type d'entreprise",
            "lang": "Langue",
            "state": "État",
            "single": "Unique",
            "iGroup": "Est-il un groupe?",
            "belongs": "Appartient",
            "country": "Pays",
            "isGroup": "Appartient-il à un groupe?",
            "is-group": "Groupe?",
            "deleteTitle": "Suppression de l'entreprise {name}",
            "deleteMessage": "Êtes-vous sûr de vouloir supprimer l'entreprise?",
            "deleteConfirmTitle": "L'entreprise a été supprimée",
            "deleteConfirm": "L'entreprise a été supprimée",
            "deleteError": "Une erreur s'est produite pendant la suppression",
            "editTitle": "Édition de l'entreprise {name}",
            "editMessage": "L'entreprise a été éditée",
            "addTitle": "Ajout d'une nouvelle entreprise",
            "imgText": "Glissez et déposez l'image ou cliquez ici",
            "unlock": "Déverrouiller",
            "lock": "Verrouiller",
            "link": "Lien vers le canal de plaintes:",
            "typeRed": "Type rouge",
            "typeBlue": "Type bleu",
            "typeGreen": "Type vert",
            "typeOrange": "Type orange"
        },
        "fonts": {
            "title": "Maintenance des polices",
            "name": "Nom",
            "deleteTitle": "Suppression de la police {name}",
            "deleteMessage": "Êtes-vous sûr de vouloir supprimer la police?",
            "deleteConfirmTitle": "La police a été supprimée",
            "deleteConfirm": "La police a été supprimée",
            "deleteError": "Une erreur s'est produite pendant la suppression",
            "editTitle": "Édition de la police {name}",
            "editMessage": "La police a été éditée",
            "addTitle": "Ajout d'une nouvelle police"
        }
    },
    "mCompany": {
        "users": {
            "title": "Maintenance des utilisateurs",
            "name": "Nom",
            "password": "Mot de passe",
            "email": "Email",
            "dni": "DNI",
            "user": "Utilisateur",
            "governingBody": "Organe de gouvernance",
            "compliance": "Officier de conformité",
            "rol": "Sélectionnez un rôle",
            "rolTable": "Rôle",
            "deleteTitle": "Suppression de l'utilisateur {name}",
            "deleteMessage": "Êtes-vous sûr de vouloir supprimer l'utilisateur?",
            "deleteConfirmTitle": "L'utilisateur a été supprimé",
            "deleteConfirm": "L'utilisateur a été supprimé",
            "deleteError": "Une erreur s'est produite pendant la suppression",
            "editTitle": "Édition de l'utilisateur {name}",
            "editMessage": "L'utilisateur a été édité",
            "addTitle": "Ajout d'un nouvel utilisateur",
            "state": "État",
            "signature": "A-t-il une signature numérique?"
        },
        "departments": {
            "title": "Maintenance des départements",
            "name": "Nom",
            "deleteTitle": "Suppression du département {name}",
            "deleteMessage": "Êtes-vous sûr de vouloir supprimer le département?",
            "deleteConfirmTitle": "Le département a été supprimé",
            "deleteConfirm": "Le département a été supprimé",
            "deleteError": "Une erreur s'est produite pendant la suppression",
            "editTitle": "Édition du département {name}",
            "editMessage": "Le département a été édité",
            "addTitle": "Ajout d'un nouveau département"
        },
        "headquarters": {
            "title": "Maintenance des sièges",
            "name": "Nom",
            "deleteTitle": "Suppression du siège {name}",
            "deleteMessage": "Êtes-vous sûr de vouloir supprimer le siège?",
            "deleteConfirmTitle": "Le siège a été supprimé",
            "deleteConfirm": "Le siège a été supprimé",
            "deleteError": "Une erreur s'est produite pendant la suppression",
            "editTitle": "Édition du siège {name}",
            "editMessage": "Le siège a été édité",
            "addTitle": "Ajout d'un nouveau siège"
        },
        "mylink": {
            "title": "Mes liens",
            "linkForms": "Liens vers les formulaires",
            "linkUser": "Liens vers la connexion utilisateur",
            "linkWhistleblower": "Lien vers le statut de votre consultation"
        },
        "statistic": {
            "title": "Mes statistiques"
        }
    },
    "mUser": {
        "mydata": {
            "title": "Mes données"
        },
        "chistory": {
            "title": "Historique des cas",
            "titleAnalysis": "Historique des cas > Analyse",
            "titleDecision": "Historique des cas > Décision",
            "titleComunication": "Historique des cas > Communication",
            "date": "Date",
            "type": "Type",
            "user": "Fermé par",
            "code": "Code",
            "governingBody": "Organe de gouvernance",
            "compliance": "Officier de conformité",
            "consult": "Consultation",
            "anonymous": "Anonyme",
            "nominal": "Nominal",
            "case": "CAS",
            "seecomunication": "Dénonciateur"
        },
        "ocases": {
            "title": "Cas ouverts",
            "time": "Terme",
            "intime": "À l´heure",
            "outtime": "Hors du temps",
            "titleAnalysis": "Cas ouverts > Analyse",
            "titleDecision": "Cas ouverts > Décision",
            "titleComunication": "Cas ouverts > Communication",
            "date": "Date",
            "type": "Type",
            "question": "Question",
            "answer": "Réponse",
            "nature": "Nature",
            "phase": "Phase",
            "user": "Assigné à",
            "code": "Code",
            "governingBody": "Organe de gouvernance",
            "compliance": "Officier de conformité",
            "consult": "Consultation",
            "anonymous": "Anonyme",
            "nominal": "Nominal",
            "danonymous": "Plainte Anonyme",
            "dnominal": "Plainte Nominal",
            "isCrime": "Y a-t-il un crime lié à la consultation/plainte?",
            "crimes": "Introduisez le/les crimes associés",
            "investigation": "Enquêtes",
            "author": "Auteur",
            "uploadFile": "Fichiers téléchargés par le dénonciateur",
            "files": {
                "name": "Nom",
                "date": "Date",
                "download": "Télécharger"
            },
            "authors": {
                "name": "Nom",
                "date": "Date"
            },
            "close": "Fermer la consultation",
            "closedenu": "Fermer la phase",
            "invPhase": {
                "title": "Phase d'enquête",
                "text": "Réponse",
                "cause": "Analyse des causes",
                "observation": "Observations",
                "relevant": "Est-ce pertinent?",
                "conclusionPhase2": "Conclusion finale",
                "yes": "Oui",
                "no": "Non"
            },
            "falsa": "Fausse déclaration",
            "avisoFAS": "En appuyant sur le bouton envoyer, la plainte sera finalisée",
            "ajenos": "Données personnelles d'autrui",
            "sensibles": "Données sensibles",
            "anadirusuario": "Ajouter un utilisateur à l'enquête",
            "asistenteia": "Assistant IA",
            "newPregunta": "Nouvelle question",
            "falseMensaje": "Des actions en justice vont-elles être entreprises?",
            "exportCase": "Exporter le cas",
            "caseType": "Type de cas: ",
            "create": "CRÉÉE",
            "analysis": "ANALYSE",
            "decision": "DÉCISION",
            "comunication": "COMMUNICATION",
            "finished": "FINIE",
            "deleteTitle": "Suppression du fichier",
            "deleteMessage": "Êtes-vous sûr de vouloir supprimer le fichier?",
            "relevant": "Est-ce pertinent?",
            "attachFile": "Fichier joint :",
            "seephase": "Analyse",
            "high": "HAUT",
            "medio": "MOYEN",
            "low": "BAS",
            "priorityComplaint": "Priorité de la plainte",
            "activateFiles": "Activer le téléchargement de fichiers pour le dénonciateur",
            "activateMessages": "Activer la zone de messages pour le dénonciateur",
            "mensajeConfirmacion": "Êtes-vous sûr de vouloir fermer cette phase? Il ne sera pas possible de revenir en arrière",
            "phase3": {
                "title": "CAS ",
                "final": "Décision finale",
                "people": "Décisions concernant les personnes touchées",
                "compliance": "Décisions concernant le système de conformité",
                "organization": "Décisions concernant l'organisation du travail",
                "compliant": "Décisions concernant d'autres parties prenantes impliquées dans la plainte",
                "comunication": "Décisions concernant la communication",
                "other": "Autres décisions",
                "observation": "Observations",
                "save": "Sauvegarder",
                "close": "Fermer",
                "btnpeople": "Personnes touchées",
                "btncompliance": "Système de conformité",
                "btnorganization": "Organisation du travail",
                "btncompliant": "Autres parties prenantes impliquées",
                "btncomunication": "Communication",
                "btnother": "Autres",
                "message": "Le texte de la consultation/plainte est : ",
                "messagedenu": "Le texte de la consultation/plainte est : ",
                "seephase": "Décision",
                "return": "Retour",
                "cause": "Causes de la phase",
                "observationphase2": "Observation de la phase",
                "relevant": "Est pertinent",
                "conclusionPhase2": "Conclusion de la phase",
                "nodecision": "La plainte n'a pas de décisions",
                "decisionfinal": "Décision finale"
            },
            "phase4": {
                "title": "CAS ",
                "people": "Communications aux personnes touchées",
                "responsible": "Communications aux responsables des personnes touchées",
                "organization": "Communication au reste de l'organisation",
                "compliant": "Communication au dénonciateur",
                "adminpublic": "Communication à l'administration publique",
                "other": "Communication à d'autres parties prenantes",
                "observation": "Observations",
                "save": "Sauvegarder",
                "close": "Fermer",
                "btnpeople": "Personnes touchées",
                "btnresponsible": "Responsables",
                "btnorganization": "Reste de l'organisation",
                "btncompliant": "Dénonciateur",
                "btnadminpublic": "Administration publique",
                "btnother": "Autres",
                "message": "Le texte de la consultation/plainte est : ",
                "messagedenu": "Le texte de la consultation/plainte est : ",
                "seephase": "Communication",
                "return": "Retour",
                "cause": "Causes de la phase",
                "observationphase2": "Observation de la phase",
                "relevant": "Est pertinent",
                "conclusionPhase2": "Conclusion de la phase",
                "channel": "Canal/moyen de communication utilisé",
                "email": "Adresse e-mail",
                "phone": "Téléphone",
                "presencial": "Présentiel",
                "otherchannel": "Autres",
                "nocomunication": "La plainte n'a pas de communications",
                "resolucion": "Informations de résolution pour le dénonciateur",
                "ultentrada": "Dernière connexion"
            },
            "messages": {
                "date": "Date",
                "text": "Message",
                "title": "Messages"
            },
            "filesUsu": {
                "title": "Fichiers du dénonciateur"
            },
            "InviUsu": {
                "title": "Utilisateurs ajoutés",
                "name": "Nom",
                "motivo": "Motif"
            }
        }
    },
    "mwhistleblower": {
        "title": "Dénonciateur",
        "case": "CAS - ",
        "uploadFile": "Télécharger des fichiers",
        "message": "Messages",
        "state": "ÉTAT ACTUEL DE LA PLAINTE/CONSULTATION : ",
        "finished": "ÉTAT ACTUEL DE LA PLAINTE/CONSULTATION : TERMINÉE",
        "comunication": "ÉTAT ACTUEL DE LA PLAINTE/CONSULTATION : COMMUNICATION",
        "decision": "ÉTAT ACTUEL DE LA PLAINTE/CONSULTATION : DÉCISION",
        "analysis": "ÉTAT ACTUEL DE LA PLAINTE/CONSULTATION : EN COURS",
        "created": "ÉTAT ACTUEL DE LA PLAINTE/CONSULTATION : CRÉÉE",
        "messagetext": "Tapez votre message ici...",
        "messageTitle": "Message"
    },
    "phases": {
        "actions": {
            "close": "Fermer le cas",
            "save": "Enregistrer",
            "addFile": "Joindre un nouveau fichier",
            "seeFiles": "Voir l'historique des fichiers",
            "seePDF": "Voir l'historique PDF"

        },
        "id": "ID",
        "date": "Date",
        "type": "Type",
        "state": "État",
        "lastUser": "Dernier utilisateur",
        "commentary": "Commentaire"
    },
    "statistics": {
        "title": "FILTRE",
        "date_ini": "Date de début",
        "date_fin": "Date de fin",
        "type": "Type",
        "relation": "Relation",
        "font": "Source",
        "nature": "Nature",
        "priority": "Priorité",
        "appropriate": "Pertinent",
        "msede": "Siège",
        "mdepa": "Département",
        "state": "État",
        "create": "Créée",
        "analysis": "Analyse",
        "decision": "Décision",
        "fin": "Finie",
        "consulta": "Consultation",
        "anonimo": "Anonyme",
        "nominal": "Nominatif",
        "Tcreate": "CRÉÉES",
        "Tanalysis": "ANALYSE",
        "Tdecision": "DÉCISION",
        "Tcomunicacion": "COMMUNICATION",
        "Tfin": "FINIES",
        "nomfont": "NOM DE LA SOURCE",
        "numfont": "TOTAL",
        "total": "Total des plaintes",
        "ptotal": "Pourcentage total",
        "filter": "Filtrées",
        "pfilter": "Pourcentage filtré",
        "resume": "RÉSUMÉ",
        "pstate": "PAR ÉTAT",
        "pfuente": "PAR SOURCE",
        "department": "DÉPARTEMENT",
        "sede": "SIÈGE",
        "listdenu": "DÉTAIL",
        "date": "Date"
    },
    "search": {
        "title": "Recherche de plaintes/consultations par code",
        "search": "Rechercher",
        "code": "Code",
        "whistleblower": "Lanceur d'alerte"
    },
    "errors": {
        "0": "Données enregistrées correctement",
        "1": "Une erreur s'est produite.",
        "1.1": "Vérifiez les données du formulaire",
        "2": "L'enregistrement existe déjà",
        "3": "Il n'y a pas d'enregistrements",
        "4": "Utilisateur débloqué",
        "8": "Utilisateur bloqué",
        "5": "Entreprise débloquée",
        "9": "Entreprise bloquée",
        "6": "Une erreur s'est produite. Veuillez réessayer plus tard.",
        "7": "Vous devez sélectionner un certificat pour pouvoir clôturer le cas",
        "title": "Avis",
        "fieldOb": "Vous devez remplir tous les champs obligatoires (*) et accepter la politique de confidentialité",
        "comment": "Les champs avec * sont obligatoires",
        "comment2": "Tous les champs marqués d'un astérisque (*) sont obligatoires.",
        "acuse": "Accusé de réception",
        "errorEmail": "Le format de l'email n'est pas valide"
    },
    "export": {
        "title": "Exporter",
        "case": "Cas",
        "name": "Nom: ",
        "surname": "Prénoms: ",
        "email": "Email: ",
        "phone": "Téléphone: ",
        "relation": "Relation: ",
        "organization": "Organisation: ",
        "nature": "Nature: ",
        "offense": "Offense: ",
        "consultation": "Consultation: ",
        "type": "Type: ",
        "department": "Département: ",
        "priority": "Priorité: ",
        "headquarters": "Siège: "
    },
    "configuration": {
        "email": "Courrier électronique",
        "user": "Utilisateur",
        "password": "Mot de passe",
        "server": "Serveur",
        "port": "Port",
        "security": "Sécurité",
        "nosec": "Sans sécurité",
        "footer": "Pied de page légal RGPD",
        "save": "Enregistrer la configuration",
        "repeatPassword": "Répétez le mot de passe",
        "messageError": "Les mots de passe sont différents",
        "messageError2": "Le mot de passe doit avoir au moins 8 caractères et contenir une majuscule, une minuscule, un numéro et un symbole.",
        "change": "Enregistrer",
        "changePassword": "Changement de mot de passe",
        "newPassword": "Nouveau mot de passe",
        "pprivacity": "Url Politique de Confidentialité",
        "advise": "Si c'est la première fois que vous entrez, allez à la fin du formulaire et changez le mot de passe de l'entreprise."
    },
    "legal": {
        "cookieNotice": "Ce site web n'utilise que ses propres cookies à des fins techniques, il ne recueille ni ne transfère les données personnelles des utilisateurs sans leur connaissance. Cependant, il contient des liens vers des sites web tiers avec des politiques de confidentialité différentes de la nôtre que vous pouvez choisir d'accepter ou non lorsque vous y accédez. Si vous souhaitez plus d'informations, consultez notre Politique en matière de cookies en cliquant ",
        "cookieNoticeRef": "ici",
        "pprivacity": "Politique de Confidentialité",
        "legalWarn": "Avertissement Légal",
        "pcookies": "Politique de Cookies",
        "asistenteIa": "Les informations fournies par cette intelligence artificielle sont uniquement à titre informatif et ne doivent en aucun cas être interprétées comme des conseils juridiques ou professionnels. Pour des conseils spécifiques, il est recommandé de consulter un professionnel qualifié."
    }
}